export const ORDER_MODES = Object.freeze(["counter", "table", "both"]);
export const ORDER_STATUSES = Object.freeze(["new", "preparing", "ready", "completed", "cancelled"]);
export const ACTIVE_ORDER_STATUSES = Object.freeze(["new", "preparing", "ready"]);
export const DEFAULT_TAX_SETTINGS = Object.freeze({ enabled: true, rate: 5, showTax: true });

const LEGACY_STATUS = Object.freeze({ pending: "new", delivered: "completed" });

export const normalizeOrderMode = (mode) => ORDER_MODES.includes(mode) ? mode : "counter";
export const normalizeOrderStatus = (status) => ORDER_STATUSES.includes(status) ? status : (LEGACY_STATUS[status] || "new");

export function normalizeRestaurantOrder(order) {
  const source = order?.source === "table" ? "table" : "counter";
  return {
    ...order,
    status: normalizeOrderStatus(order?.status),
    source,
    tableId: source === "table" && typeof order?.tableId === "string" ? order.tableId : null,
    tableLabel: source === "table" && typeof order?.tableLabel === "string" ? order.tableLabel : null,
    tableClosedAt: order?.tableClosedAt || null,
  };
}

export function canTransitionOrder(current, next) {
  const from = normalizeOrderStatus(current);
  const to = normalizeOrderStatus(next);
  const sequence = ["new", "preparing", "ready", "completed"];
  return sequence.indexOf(to) === sequence.indexOf(from) + 1;
}

export const canCancelOrder = (status) => ["new", "preparing", "ready"].includes(normalizeOrderStatus(status));
export const canAddItems = (status) => ["new", "preparing"].includes(normalizeOrderStatus(status));

export function normalizeTaxSettings(settings) {
  const rate = Number(settings?.rate);
  return {
    enabled: typeof settings?.enabled === "boolean" ? settings.enabled : true,
    rate: Number.isFinite(rate) && rate >= 0 && rate <= 100 ? rate : 5,
    showTax: typeof settings?.showTax === "boolean" ? settings.showTax : true,
  };
}

export function validateTaxRate(value) {
  const rate = Number(value);
  return Number.isFinite(rate) && rate >= 0 && rate <= 100
    ? { ok: true, rate }
    : { ok: false, error: "Tax percentage must be between 0 and 100." };
}

export function calculateOrderTotals(items, taxRate = 0.05, taxEnabled = true) {
  const subtotal = items.reduce((sum, item) => sum + Number(item.price) * Number(item.qty), 0);
  const tax = taxEnabled ? Math.round(subtotal * taxRate) : 0;
  return { subtotal, tax, total: subtotal + tax };
}
